export default "__VITE_ASSET__BiQOXiv9__"